import { Routes, Route } from "react-router-dom";
import AgentForm from "./components/AgentForm";
import Dashboard from "./screens/Dashboard";
import Hearings from "./components/Hearings";
import HearingDetails from "./screens/HearingDetails";
import PrivateRoute from "./components/hoc/PrivateRoute";
import SendCode from "./components/SendCode";
import AgentEditForm from "./components/AgentEditForm";
import HistoryPage from "./screens/HistoryPage";
import AgentEvaluationPublic from "./screens/AgentEvaluationPublic";
import CoursesPage from "./screens/CoursesPage";
import CourseDetail from "./screens/CourseDetail";
import CourseLesson from "./screens/CourseLesson";
import CourseExam from "./screens/CourseExam";
import CertificateValidatePage from "./screens/CertificateValidatePage";

const App: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<SendCode />} />
      <Route path="/evaluation/:token" element={<AgentEvaluationPublic />} />
      <Route path="/certificates/validate" element={<CertificateValidatePage />} />
      <Route
        path="/certificates/validate/:code"
        element={<CertificateValidatePage />}
      />
      <Route path="/registration" element={<AgentForm agent={null} />} />
      <Route
        path="/dashboard"
        element={<PrivateRoute element={<Dashboard />} />}
      />
      <Route
        path="/profile"
        element={<PrivateRoute element={<AgentEditForm />} />}
      />
      <Route
        path="/hearings"
        element={<PrivateRoute element={<Hearings />} />}
      />
      <Route
        path="/hearings/:id"
        element={<PrivateRoute element={<HearingDetails />} />}
      />
      <Route
        path="/history"
        element={<PrivateRoute element={<HistoryPage />} />}
      />
      <Route
        path="/courses"
        element={<PrivateRoute element={<CoursesPage />} />}
      />
      <Route
        path="/courses/:id"
        element={<PrivateRoute element={<CourseDetail />} />}
      />
      <Route
        path="/courses/:id/lessons/:lessonId"
        element={<PrivateRoute element={<CourseLesson />} />}
      />
      <Route
        path="/courses/:id/lessons/:lessonId/exam"
        element={<PrivateRoute element={<CourseExam />} />}
      />
    </Routes>
  );
};

export default App;
